import reducerSettings from './reducer';

export default reducerSettings;
export * from './selectors';
export * from './actions';
export * from './reducer';